import React from "react";
import { Typography, Grid, Box, Container, Button, Link } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import parse from "html-react-parser";

type CustomerSupportLandingType = {
  DomPurify: Function;
  translatedData: {
    imageUrl: string;
    imageAltText: string;
    imageWidth: string;
    imageHeight: string;
    header: string;
    paragraph: string;
    linkText: string;
    linkUrl: string;
    linkAriaLabel: string;
  };
};

const CustomerSupportLanding = (props: CustomerSupportLandingType) => {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: { xs: "column", lg: "row" },
        borderRadius: { sm: "10px", xs: "0px" },
        alignItems: { lg: "flex-end", sm: "stretch", xs: "center" },
        padding: { xs: "0rem", lg: "0px" },
        backgroundColor: "#4a4f54",
        maxWidth: {
          xs: "360px",
          sm: "768px",
          lg: "1280px",
        },
        marginTop: { lg: "10px", sm: "0px", xs: "0px" },
        marginBottom: { lg: "10px", sm: "4px" },
      }}
    >
      {/* Header and Texts */}
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems={{ lg: "flex-start", xs: "center" }}
        sx={{
          marginTop: { lg: "36px", sm: "0px", xs: "5px" },
          zIndex: "2",
          padding: { xs: "24px", sm: "0px 62px", lg: "0px 25px 0px 110px" },
        }}
      >
        <Grid item mt={5}>
          <Typography
            variant="h2"
            sx={{
              textAlign: { lg: "left", sm: "center", xs: "center" },
              fontSize: { lg: "36px", sm: "28px", xs: "28px" },
              marginBottom: "22px",
              color: "#ffffff !important",
            }}
          >
            {parse(props.translatedData.header)}
          </Typography>
        </Grid>

        <Grid item>
          <Typography
            sx={{
              color: "#ffffff",
              fontSize: { lg: "18px", xs: "16px" },
              textAlign: { lg: "left", sm: "center", xs: "center" },
              lineHeight: "1.56",
              padding: { xs: "0px 18.5px", sm: "0px 0px 0px 0px", lg: "0px" },
            }}
          >
            {parse(props.translatedData.paragraph)}
          </Typography>
        </Grid>

        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          sx={{
            width: { lg: "auto", sm: "100%", xs: "auto" },
            marginBottom: { xs: "16px", sm: "0px" },
          }}
        >
          <Button
            variant="outlined"
            component={Link}
            size="large"
            aria-label={props.translatedData.linkAriaLabel}
            href={props.translatedData.linkUrl}
            className="secondary-btn-white"
            sx={{
              fontSize: "16px",
              fontWeight: "bold !important",
              marginTop: { lg: "40px", xs: "16px" },
              marginBottom: { lg: "76px", sm: "40px" },
              padding: "0px 15px",
              textAlign: "center",
              border: "#ffffff solid 1px !important",
              color: "#ffffff !important",
              width: { xs: "292px !important", sm: "292px !important", lg: "218px !important" },
              height: { xs: "44px", sm: "44px", lg: "56px" },
              whiteSpace: "wrap",
              "&:hover": {
                backgroundColor: "#616A6B !important",
              },
            }}
          >
            {props.translatedData.linkText}
            {/* <LazyLoadImage
              effect="blur"
              src="https://media.ctfs.com/pages/CRECRD/CRECRD_External_Action.svg"
              alt=""
              style={{
                lineHeight: "1.13",
                maxWidth: "14px",
                marginLeft: "10px",
              }}
            /> */}
          </Button>
        </Grid>
      </Grid>

      <Box
        component="img"
        src={props.translatedData.imageUrl}
        alt={props.translatedData.imageAltText}
        sx={{
          width: { sm: "auto", xs: "100%" },
          // marginTop: { sm: "auto", xs: "-70px" },
          // objectPosition: { lg: "0px", sm: "-50px 0px", xs: "-6px 55px" },
          // objectFit: { lg: "contain", sm: "cover", xs: "contain" },
          // height: { lg: "auto", sm: "100%", xs: "auto" },
          borderRadius: { sm: "10px", xs: "0px" },
        }}
      />
      {/* </Box> */}
    </Container>
  );
};

export default CustomerSupportLanding;
